import React, { Component } from 'react';

import { Row, Col, Form, Button, Collapse, Toast } from 'react-bootstrap';
import ReactTable from 'react-table-v6';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync, faAngleDown, faAngleUp, faSearch } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle, faTrashAlt, faTimesCircle, faUser, faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import 'react-table-v6/react-table.css';
import './modelDetailsStyle.scss';
import { errorHandler } from '../../../../shared/utils';
import modelDetailsService from './modelDetailsService';
import { userChangeAction } from '../../../../stores/actions/userData';
import modelListService from '../../../ModelLanding/modelListService';
import { modalOnCloseAction } from '../../../../stores/actions/modalOnChange';
import {
    modelChangeAction,
    isModelUpdatedAction,
    setModifiedDateAction,
} from '../../../../stores/actions/modelDetails';
import {
    setModelActualAction,
    setModelInitialAction,
    isParametersOrVariablesUpdatedAction,
} from '../../../../stores/actions/modelInputReader';
import { updateLookerFrameAction } from '../../../../stores/actions/lookerActions';
import { updateLookerTabsVisited } from '../../../../stores/actions/lookerActions';

import swal from 'sweetalert';
import { lookerParams } from '../../../../shared/lookerParams';
import moment from 'moment-timezone';
import { ModelHelper } from '../../modelFunctions';
import { Config } from '../../../../shared/config';

class ModelDetails extends Component {
    constructor(props) {
        super(props);
        let session = localStorage.getItem('FOM_user');
        this.state = {
            modelList: [],
            versionTypeList: [],
            pages: null,
            loading: false,
            showPagination: false,
            showModelList: false,
            showCustomerList: false,
            searchModelText: '',
            searchCustomerText: null,
            open: null,
            modelData: {},
            createdDate: '',
            createdBy: '',
            modifiedDate: '',
            modifiedBy: '',
            showToast: false,
            showError: true,
            masterModel: null,
            validator: {
                name: false,
                version: false,
            },
            api: {
                response: {
                    status: '',
                    message: '',
                },
            },
            fieldModelName: '',
            fieldModelVersion: '',
            fieldModelVersionType: 'DRAFT',
            fieldModelNotes: '',
            userdata: session ? JSON.parse(session).userdata.details : null,
            lookerParams: {},
        };

        this.setModelWrapperRef = this.setModelWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.setOpen = this.setOpen.bind(this);
        this.tableRowClick = this.tableRowClick.bind(this);
        this.versionTypeChange = this.versionTypeChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.modelListService = new modelListService();
        this.modelDetailsService = new modelDetailsService();
    }

    mapLookerUrls(lookerPaths) {
        return lookerPaths;
    }

    initialResetFlags() {
        return {
            Addressable: false,
            InputVariables: false,
            RevenueByPayor: false,
            RevenueOpportunity: false,
            AddrRevByPayor: false,
            MarginByPayor: false,
            AddrMarginByPayor: false,
            FiveYearProjections: false,
            FiveYearProjectionsLoaded: false,
        };
    }

    /**
     * Toggle toast
     */
    toggleToast = () => {
        const { showToast } = this.state;
        this.setState({
            showToast: !showToast,
        });
        setTimeout(() => {
            this.setState({
                showToast: false,
            });
        }, 4000);
    };

    /**
     * Set modified date
     */
    setModifiedDate = () => {
        this.setState({
            modifiedBy: this.props.modelModifiedDate.datePayload.modifiedBy,
            modifiedDate: moment
                .utc(this.props.modelModifiedDate.datePayload.modifiedDate, Config.UI_TIMESTAMP_FORMAT)
                .local(),
        });
        this.props.updateModifiedDate(null);
    };

    /**
     * Props change auto invoke function
     */
    static getDerivedStateFromProps(props, current_state) {
        if (
            props.modelModifiedDate &&
            props.modelModifiedDate.datePayload
        ) {
            if (current_state.modelData && current_state.modelData.modelId) {
                return {
                    modifiedBy: props.modelModifiedDate.datePayload.modifiedBy,
                    modifiedDate: moment
                        .utc(props.modelModifiedDate.datePayload.modifiedDate, Config.UI_TIMESTAMP_FORMAT)
                        .local(),
                };
            }
        }
        return null;
    }

    /**
     * Rendering ui elements
     */
    render() {
        const {
            modelList,
            loading,
            showPagination,
            showModelList,
            modelData,
            createdDate,
            createdBy,
            modifiedDate,
            modifiedBy,
            showToast,
            api,
            fieldModelName,
            fieldModelVersion,
            fieldModelVersionType,
            fieldModelNotes,
            validator,
            showError,
            versionTypeList,
            masterModel,
        } = this.state;
        const displayModalList = showModelList ? 'd-block' : 'd-none';
        let { open } = this.state;
        let showActionButtons = false;
        let showSaveButton = false;

        const processedCreatedDate = createdDate
            ? moment(createdDate, Config.API_TIMESTAMP_FORMAT).format(Config.UI_TIMESTAMP_FORMAT)
            : null;
        const processedModifiedDate = modifiedDate
            ? moment(modifiedDate, Config.API_TIMESTAMP_FORMAT).format(Config.UI_TIMESTAMP_FORMAT)
            : null;

        if (this.props.paramsVariablesUpdated.status && modelData.modelId) {
            showActionButtons = true;
            showSaveButton = true;
        }
        if (open === null) {
            open = !modelData.modelId;
        }

        if (this.props.isModelUpdated && this.props.isModelUpdated.status) {
            showActionButtons = true;
            showSaveButton = true;
        }

        if (!modelData.modelId) {
            if (fieldModelName && fieldModelVersion) showSaveButton = true;
        } else {
            if (showError && validator.version) showSaveButton = false;
        }

        /**
         * Return html elements
         */
        return (
            <div className="dummy">
                <Row>
                    <Col md={12}>
                        <div className="box-head" onClick={this.setOpen}>
                            <p className="m-0">
                                MODEL DETAILS &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                {modelData.modelName ? (
                                    <span className="model-name-text">{modelData.modelName}</span>
                                ) : (
                                    ''
                                )}
                                {modelData.version ? (
                                    <span className="model-name-text">{', ' + modelData.version}</span>
                                ) : (
                                    ''
                                )}
                                {modelData.versionType ? (
                                    <span className="model-name-text">{' (' + modelData.versionType + ')'}</span>
                                ) : (
                                    ''
                                )}
                            </p>
                            <div className="icon-box">
                                {open ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}
                            </div>
                        </div>
                    </Col>
                </Row>
                {/* Collapse container for  model details */}
                <Collapse in={open} className="pt-3">
                    <Row>
                        <Col sm={12} md={7} lg={6} className="col-12">
                            <div className="left-border">
                                <Form.Group className="form-inline pt-2">
                                    <Col sm={2} md={2} lg={1} className="text-left col-2">
                                        <Form.Label className="model-field-label text-nowrap required">
                                            Name
                                            {/* <span className="semi-col">:</span> */}
                                        </Form.Label>
                                    </Col>
                                    <Col sm={10} md={10} lg={11} className="col-10">
                                        <div className="model-search-wrapper">
                                            <Form.Control
                                                type="text"
                                                size="sm"
                                                placeholder="Model Name"
                                                name="fieldModelName"
                                                className={` ${validator.name && showError ? 'form-error' : ''}`}
                                                disabled={
                                                    masterModel && masterModel.modelId === modelData.modelId
                                                        ? 'disabled'
                                                        : null
                                                }
                                                onChange={this.handleInputChange}
                                                value={modelData.modelName}
                                                autoComplete="none"
                                                id="model-name"
                                            />
                                            {validator.name && showError ? (
                                                <span className="error">Model Name is required</span>
                                            ) : null}
                                            {modelData && modelData.modelId ? (
                                                <FontAwesomeIcon
                                                    icon={faSearch}
                                                    className="search-icon search-icon-box"
                                                />
                                            ) : null}
                                            {modelData && modelData.modelId ? (
                                                <div
                                                    className={`model-search-box ${displayModalList}`}
                                                    ref={this.setModelWrapperRef}
                                                >
                                                    <ReactTable
                                                        columns={[
                                                            {
                                                                Header: 'Model Name',
                                                                accessor: 'modelName',
                                                                width: getColumnWidth(
                                                                    modelList,
                                                                    'modelName',
                                                                    'Model Name',
                                                                ),
                                                            },
                                                            {
                                                                Header: 'Version',
                                                                accessor: 'version',
                                                                width: getColumnWidth(modelList, 'version', 'Version'),
                                                            },
                                                            {
                                                                Header: 'Version Type',
                                                                accessor: 'versionType',
                                                                width: getColumnWidth(
                                                                    modelList,
                                                                    'versionType',
                                                                    'Version Type',
                                                                ),
                                                            },
                                                            {
                                                                Header: 'Customer',
                                                                accessor: 'customerName',
                                                                width: getColumnWidth(
                                                                    modelList,
                                                                    'customerName',
                                                                    'Customer',
                                                                ),
                                                            },
                                                            {
                                                                Header: 'Created Date',
                                                                accessor: 'createdDate',
                                                                width: getColumnWidth(
                                                                    modelList,
                                                                    'createdDate',
                                                                    'Created Date',
                                                                ),
                                                            },
                                                            {
                                                                Header: 'Created By',
                                                                accessor: 'createdBy',
                                                                width: getColumnWidth(
                                                                    modelList,
                                                                    'createdBy',
                                                                    'Created By',
                                                                ),
                                                            },
                                                        ]}
                                                        //manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                                                        data={modelList}
                                                        loading={loading} // Display the loading overlay when we need it
                                                        noDataText="No Models found"
                                                        minRows={modelList.length}
                                                        showPagination={showPagination}
                                                        pageSize={modelList.length ? modelList.length : 1}
                                                        className="-striped -highlight h-100 cursor-pointer"
                                                        getTrProps={(state, rowInfo) => {
                                                            return {
                                                                onClick: () => {
                                                                    this.tableRowClick(rowInfo);
                                                                },
                                                            };
                                                        }}
                                                    />
                                                </div>
                                            ) : null}
                                        </div>
                                    </Col>
                                </Form.Group>

                                <Form.Group className="form-inline">
                                    <Col sm={2} md={2} lg={1} className="text-left col-2">
                                        <Form.Label className=" model-field-label text-nowrap required">
                                            Version
                                            {/* <span className="semi-col">:</span> */}
                                        </Form.Label>
                                    </Col>
                                    <Col sm={4} md={5} lg={7} className="col-4">
                                        <Form.Control
                                            type="text"
                                            size="sm"
                                            name="fieldModelVersion"
                                            id="version"
                                            className={` ${validator.version && showError ? 'form-error' : ''}`}
                                            disabled={
                                                masterModel && masterModel.modelId === modelData.modelId
                                                    ? 'disabled'
                                                    : null
                                            }
                                            onChange={this.handleInputChange}
                                            placeholder="Model Version"
                                            value={fieldModelVersion}
                                        />
                                        {validator.version && showError ? (
                                            <span className="error">Version is required</span>
                                        ) : null}
                                    </Col>
                                    <Col sm={3} md={2} lg={2} className="pl-2 col-3 div-version-type">
                                        <Form.Label className="model-field-label text-nowrap required">
                                            Version Type
                                            {/* <span className="semi-col">:</span> */}
                                        </Form.Label>
                                    </Col>
                                    <Col sm={3} md={3} lg={2} className="pl-0 col-3">
                                        {/* onChange={(e) => { this.versionTypeChange(e) }} */}
                                        <Form.Control
                                            as="select"
                                            size="sm"
                                            name="fieldModelVersionType"
                                            id="version-type"
                                            disabled={
                                                masterModel && masterModel.modelId === modelData.modelId
                                                    ? 'disabled'
                                                    : null
                                            }
                                            onChange={this.handleInputChange}
                                            value={fieldModelVersionType}
                                        >
                                            {versionTypeList.map((key) => (
                                                <option key={key} value={key}>
                                                    {key}
                                                </option>
                                            ))}
                                            ;
                                        </Form.Control>
                                    </Col>
                                </Form.Group>
                                <Form.Group className="form-inline">
                                    <Col sm={2} md={2} lg={1} className="col-2 text-left">
                                        <Form.Label className="model-field-label ">
                                            Notes
                                            {/* <span className="semi-col">:</span> */}
                                        </Form.Label>
                                    </Col>
                                    <Col sm={10} md={10} lg={11} className="col-10">
                                        <Form.Control
                                            as="textarea"
                                            rows="3"
                                            size="sm"
                                            name="fieldModelNotes"
                                            onChange={this.handleInputChange}
                                            value={fieldModelNotes}
                                            id="notes"
                                        />
                                    </Col>
                                </Form.Group>
                            </div>
                        </Col>

                        <Col sm={12} md={5} lg={6} className="col-12">
                            <Row className="toast-container">
                                <Col md={12} className="pt-2">
                                    <Toast className="toast-container" show={showToast} onClose={this.toggleToast}>
                                        <Toast.Header
                                            className={` ${api.response.status !== 'Failure' ? 'success' : 'error'}`}
                                        >
                                            <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                                            <strong className="mr-auto">{api.response.status}</strong>
                                        </Toast.Header>
                                        <Toast.Body>{api.response.message}</Toast.Body>
                                    </Toast>
                                </Col>
                            </Row>
                            <div className="right-border right-pane">
                                <div className="text-center button-group">
                                    <Button
                                        id="btn-save"
                                        className="btn-save"
                                        size="sm"
                                        disabled={showSaveButton ? null : 'disabled'}
                                        onClick={this.saveModel}
                                    >
                                        <FontAwesomeIcon icon={faCheckCircle} />
                                        <span className="ml-3">Save</span>
                                    </Button>{' '}
                                    <Button
                                        id="btn-reload"
                                        className="btn-reload"
                                        size="sm"
                                        disabled={showActionButtons && modelData.modelId ? null : 'disabled'}
                                        onClick={this.reloadModel}
                                    >
                                        <FontAwesomeIcon icon={faSync} />
                                        <span className="ml-3">Reload</span>
                                    </Button>{' '}
                                    <Button
                                        id="btn-delete"
                                        className="btn-delete"
                                        size="sm"
                                        disabled={
                                            !modelData.modelId ||
                                            (masterModel && masterModel.modelId === modelData.modelId)
                                                ? 'disabled'
                                                : null
                                        }
                                        onClick={this.deleteModel}
                                    >
                                        <FontAwesomeIcon icon={faTrashAlt} />
                                        <span className="ml-3">Delete</span>
                                    </Button>{' '}
                                    <Button id="btn-close" className="btn-close" size="sm" onClick={this.closeModal}>
                                        <FontAwesomeIcon icon={faTimesCircle} />
                                        <span className="ml-3">Close</span>
                                    </Button>{' '}
                                </div>
                                <div className="model-info">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                    <span className="ml-2">Created Date</span>
                                                </td>
                                                <td> {processedCreatedDate}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <FontAwesomeIcon icon={faUser} />
                                                    <span className="ml-2">Created By</span>
                                                </td>
                                                <td> {createdBy}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                    <span className="ml-2">Modified Date</span>
                                                </td>
                                                <td> {processedModifiedDate}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <FontAwesomeIcon icon={faUser} />
                                                    <span className="ml-2">Modified By</span>
                                                </td>
                                                <td> {modifiedBy}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Collapse>
            </div>
        );
    }

    /**
     * Validate the model before saving
     */
    validateModel = (params) => {
        let { validator } = this.state;

        var errors = '';

        if (!params.modelDetails.modelName || !params.modelDetails.modelName.trim()) {
            validator.name = true;
            errors = 'Invalid model name';
        }

        if (!params.modelDetails.version || !params.modelDetails.version.trim()) {
            validator.version = true;
            errors = 'Invalid model version';
        }

        if (!errors) {
            errors = ModelHelper.validateModel(params);
        }

        return errors;
    };

    /**
     * Save Model Click
     */
    saveModel = () => {
        //Set state values
        let { modelData, fieldModelName, fieldModelVersion, fieldModelVersionType, fieldModelNotes, validator } =
            this.state;

        modelData['modelName'] = modelData['modelName'] || fieldModelName;
        modelData['version'] = fieldModelVersion;
        modelData['versionType'] = fieldModelVersionType ? fieldModelVersionType : 'DRAFT';
        modelData['notes'] = fieldModelNotes;
        modelData['customerId'] = this.props.match.params.customerId;

        let variables = ModelHelper.filterComputedVariables(this.props.getInitialModels.initial.variables);

        let params = {
            modelDetails: modelData,
            variables: variables,
            parameters: this.props.getInitialModels.initial.parameters,
        };

        // validate model
        var errors = this.validateModel(params);
        if (errors) {
            //Set for error on form validation
            this.setState({
                validator: validator,
                showError: true,
                api: {
                    response: {
                        status: 'Failure',
                        message: errors,
                    },
                },
            });

            this.toggleToast();
            return;
        }

        //Invoke API to save the model
        params = jsonConcat(params, lookerParams);
        this.modelDetailsService.saveUpdateModel(params).then((res) => {
            if (res.status === 'Success' && res.data) {
                //Success response handling
                this.setState({
                    modelData: res.data.modelDetails,
                    searchModelText: res.data.modelDetails.modelName,
                    api: {
                        response: {
                            status: res.status,
                            message: res.message,
                        },
                    },
                });
                this.setState({
                    showError: true,
                    createdDate: moment.utc(this.state.modelData.createdDate, Config.UI_TIMESTAMP_FORMAT).local(),
                    createdBy: this.state.modelData.createdBy,
                    modifiedDate: moment.utc(this.state.modelData.modifiedDate, Config.UI_TIMESTAMP_FORMAT).local(),
                    modifiedBy: this.state.modelData.modifiedBy,
                });
                this.props.updateModel(res.data);
                this.props.setVariablesUpdated(false);
                this.props.setModelUpdated(false);
                this.setActualAndInitials(res.data);
                this.toggleToast();
                let lookerPaths = res.data.lookerPath;
                let lookerUrls = this.mapLookerUrls(lookerPaths);
                let resetTabFlags = this.initialResetFlags();
                this.props.updateTabVisited(resetTabFlags);
                this.props.updateLooker(lookerUrls);
            } else {
                //Error response handling
                this.setState({
                    showError: false,
                    modelData: {},
                    api: {
                        response: {
                            status: res.status,
                            message: res.message,
                        },
                    },
                });
                this.toggleToast();
            }
        });
    };

    /**
     * Reload of a model
     */
    reloadModel = () => {
        if (this.state.modelData.modelId) {
            swal({
                title: 'Are you sure to reload?',
                text: 'You will not be able to recover unsaved model!',
                icon: 'warning',
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    let param = {
                        modelId: this.state.modelData.modelId,
                        versionId: this.state.modelData.modelVersionId,
                    };
                    //Get model data from api
                    this.getModelDataById(param);
                    setTimeout(() => {
                        this.setState({
                            showError: false,
                            api: {
                                response: {
                                    status: 'Success',
                                    message: 'Successfully reloaded',
                                },
                            },
                        });
                        this.toggleToast();
                    }, 1000);
                }
            });
        } else {
            this.setState({
                showError: false,
            });
            //Get default model
            this.getDefaultModelData();
        }
    };

    /**
     * Delete model
     */
    deleteModel = () => {
        if (this.state.modelData.modelId) {
            swal({
                title: 'Are you sure to delete?',
                text: 'You will not be able to recover this!',
                icon: 'warning',
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    this.modelDetailsService.deleteModel(this.state.modelData).then((res) => {
                        if (res && res.status === 'Success') {
                            this.setState({
                                showError: false,
                                api: {
                                    response: {
                                        status: res.status,
                                        message: res.message,
                                    },
                                },
                            });
                            swal({
                                title: res.status,
                                text: res.message + ', and you will be redirected to home page',
                                icon: 'success',
                                button: 'OK',
                            }).then(() => {
                                this.props.history.push('/model/list');
                            });
                        } else {
                            this.setState({
                                showError: false,
                                api: {
                                    response: {
                                        status: res.status,
                                        message: res.message,
                                    },
                                },
                            });
                            this.toggleToast();
                        }
                    });
                }
            });
        } else {
            swal('Warning!', 'You cannot delete master model', 'warning', {
                button: 'OK',
            });
        }
    };

    /**
     * Close modal
     */
    closeModal = () => {
        if (
            !this.props.paramsVariablesUpdated.status &&
            this.props.isModelUpdated &&
            !this.props.isModelUpdated.status
        ) {
            this.props.history.push('/model/list');
        } else {
            swal({
                title: 'Are you sure to close?',
                text: 'You will not be able to recover unsaved model!',
                icon: 'warning',
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    this.props.history.push('/model/list');
                }
            });
        }
    };

    /**
     * Component mounting invoking func
     */
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        if (this.props.match.params.modelId && this.props.match.params.versionId) {
            this.getModelDataById(this.props.match.params);
            // Getting master model if admin, if yes then assign master model details
            if (localStorage.getItem('FOM_master_model')) {
                this.setState({
                    masterModel: JSON.parse(localStorage.getItem('FOM_master_model')),
                });
            }
        } else {
            this.getDefaultModelData();
        }
    }

    /**
     * Search Input field change event
     */
    modelSearch(value, modelId) {
        this.setState({ searchModelText: value, showModelList: true, loading: true }, function () {
            if (this.state.searchModelText != null) {
                this.modelDetailsService.getModelsList(this.state.searchModelText, modelId).then((res) => {
                    if (res.status === 'Success' && res.data.length > 0) {
                        const modelSearchText = res.data.modelName;
                        this.setState({
                            searchModelText: modelSearchText,
                            loading: false,
                            modelList: res.data,
                        });
                    } else {
                        this.setState({
                            loading: false,
                            showModelList: true,
                            modelList: [],
                        });
                    }
                });
            } else {
                this.setState({
                    loading: false,
                    modelList: [],
                });
            }
        });
    }

    /** Invoking when clicking a row from the model search result table
     * in the model name field
     *
     * @param {object} state - table state. /**
     * @param {object} rowInfo - clicked row data.
     */
    tableRowClick(rowInfo) {
        // eslint-disable-line
        this.setState({ showModelList: false });
        let param = { modelId: rowInfo.original.modelId, versionId: rowInfo.original.modelVersionId };
        this.getModelDataById(param);
    }

    /**
     * get model details using modelId and versionId
     */
    getModelDataById(param) {
        param = jsonConcat(param, lookerParams);
        this.modelDetailsService
            .getSingleModel(param)
            .then((res) => {
                if (res.status === 'Success' && res.data) {
                    if (res.data.modelDetails.modelId && res.data.variables && res.data.parameters) {
                        this.setActualAndInitials(res.data);

                        this.setState({
                            versionTypeList: res.data.versionTypes,
                            fieldModelVersion: res.data.modelDetails.version,
                            fieldModelVersionType: res.data.modelDetails.versionType,
                            fieldModelNotes: res.data.modelDetails.notes ? res.data.modelDetails.notes : '',
                            modelData: res.data.modelDetails,
                            searchModelText: res.data.modelDetails.modelName,
                            createdDate: moment
                                .utc(res.data.modelDetails.createdDate, Config.UI_TIMESTAMP_FORMAT)
                                .local(),
                            createdBy: res.data.modelDetails.createdBy,
                            modifiedDate: moment
                                .utc(res.data.modelDetails.modifiedDate, Config.UI_TIMESTAMP_FORMAT)
                                .local(),
                            modifiedBy: res.data.modelDetails.modifiedBy,
                        });
                        this.setState({
                            createdDate: moment
                                .utc(this.state.modelData.createdDate, Config.UI_TIMESTAMP_FORMAT)
                                .local(),
                            modifiedDate: moment
                                .utc(this.state.modelData.modifiedDate, Config.UI_TIMESTAMP_FORMAT)
                                .local(),
                        });
                        this.props.updateModel(res.data);
                        this.props.updateUser(res.data.modelDetails);
                        this.props.setVariablesUpdated(false);
                        this.props.setModelUpdated(false);
                        let lookerPaths = res.data.lookerPath;
                        let lookerUrls = this.mapLookerUrls(lookerPaths);

                        let resetTabFlags = this.initialResetFlags();
                        this.props.updateTabVisited(resetTabFlags);
                        this.props.updateLooker(lookerUrls);
                    } else {
                        swal({
                            title: 'Model not exists!',
                            text: "Model is either Deleted or doesn't exist!",
                            icon: 'error',
                            dangerMode: true,
                            button: 'OK',
                        }).then((willDelete) => {
                            if (willDelete) {
                                this.props.history.push('/model/list');
                            }
                        });
                    }
                } else {
                    this.setState({
                        modelData: {},
                    });
                }
            })
            .catch(errorHandler);
    }

    /**
     * Get default model data method
     */
    getDefaultModelData() {
        this.modelDetailsService.getDefaultModel(lookerParams).then((res) => {
            if (res.status === 'Success' && res.data) {
                this.setActualAndInitials(res.data);

                this.setState({
                    versionTypeList: res.data.versionTypes,
                });
                this.setState({
                    fieldModelVersion: res.data.modelDetails.version,
                    fieldModelVersionType: res.data.modelDetails.versionType,
                    fieldModelNotes: res.data.modelDetails.notes,
                    modelData: res.data.modelDetails,
                    searchModelText: res.data.modelDetails.modelName,
                });
                this.props.updateModel(res.data);
                let resetTabFlags = this.initialResetFlags();
                this.props.updateTabVisited(resetTabFlags);
            } else {
                this.setState({
                    modelData: {},
                });
            }
        });
    }

    /** On changing version type
     * @param {event} e - Element event data.
     */
    versionTypeChange(value) {
        let obj = this.state.modelData;
        obj['versionType'] = value;
        this.setState({
            modelData: obj,
        });
    }

    /** Input fields change event
     * @param {event} e - Element event data.
     */
    handleInputChange(event) {
        const value = event.target.value;
        const name = event.target.name;
        let { validator, modelData } = this.state;

        if (value === '') {
            if (name === 'fieldModelName') {
                if (!modelData.modelId) {
                    validator.name = true;
                }
            }
            if (name === 'fieldModelVersion') validator.version = true;
        } else {
            if (!value.trim().length) {
                if (name === 'fieldModelName') validator.name = true;
                if (name === 'fieldModelVersion') validator.version = true;
            } else {
                if (name === 'fieldModelName') validator.name = false;
                if (name === 'fieldModelVersion') validator.version = false;
            }
        }
        this.setState({
            validator,
        });
        if (modelData.modelId && name === 'fieldModelName') this.modelSearch(value, modelData.modelId);
        if (name === 'fieldModelVersionType') this.versionTypeChange(value);

        if (modelData.modelId) {
            if (name === 'fieldModelVersionType' || name === 'fieldModelVersion' || name === 'fieldModelNotes')
                this.props.setModelUpdated(true);
        }

        this.setState({
            [name]: value,
        });
    }

    setActualAndInitials(data) {
        this.props.setActualModel(data);
        this.props.setInitialModel(data);
    }

    /**
     * Invoke if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.modelWrapperRef && !this.modelWrapperRef.contains(event.target)) {
            this.setState({ showModelList: false });
        }
        if (this.customerWrapperRef && !this.customerWrapperRef.contains(event.target)) {
            this.setState({ showCustomerList: false });
        }
    }

    /**
     * Set accodion open/close
     */
    setOpen() {
        this.setState({
            open: !this.state.open,
        });
    }

    /**
     * Invoking on component unmounting
     */
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Set the wrapper ref
     */
    setModelWrapperRef(node) {
        this.modelWrapperRef = node;
    }
}

/**
 * Mapping redux state into props
 */
const MapStateToProps = (state) => {
    return {
        getActiveTab: state.getActiveTab,
        getActualModels: state.getActualAction,
        getInitialModels: state.getInitialAction,
        modelInputData: state.revParamAction,
        modelModifiedDate: state.getModifiedDateAction,
        paramsVariablesUpdated: state.paramsVariablesUpdated,
        isModelUpdated: state.isModelUpdatedAction,
        getModelStatus: state.modalOnCloseAction,
    };
};

/**
 * Dispatching redux actions
 */
const MapDispatchToProps = (dispatch) => {
    return {
        updateModel: (params) => dispatch(modelChangeAction(params)),
        updateModifiedDate: (params) => dispatch(setModifiedDateAction(params)),
        setActualModel: (params) => dispatch(setModelActualAction(params)),
        setInitialModel: (params) => dispatch(setModelInitialAction(params)),
        updateUser: (params) => dispatch(userChangeAction(params)),
        updateLooker: (params) => dispatch(updateLookerFrameAction(params)),
        setVariablesUpdated: (params) => dispatch(isParametersOrVariablesUpdatedAction(params)),
        setModelUpdated: (status) => dispatch(isModelUpdatedAction(status)),
        updateTabVisited: (params) => dispatch(updateLookerTabsVisited(params)),
        modelStatus: (params) => dispatch(modalOnCloseAction(params)),
    };
};

ModelDetails.propTypes = {
    updateModel: PropTypes.func,
    setActualModel: PropTypes.func,
    setInitialModel: PropTypes.func,
    getActualModels: PropTypes.object,
    getInitialModels: PropTypes.object,
    getActiveTab: PropTypes.object,
    setVariablesUpdated: PropTypes.func,
    setModelUpdated: PropTypes.func,
    history: PropTypes.object,
    updateLooker: PropTypes.func,
    updateTabVisited: PropTypes.func,
    modelStatus: PropTypes.object.isRequired,
};

export default connect(MapStateToProps, MapDispatchToProps)(withRouter(ModelDetails));

/**
 * Dynamic column width settings
 */
const getColumnWidth = (rows, accessor, headerText) => {
    const maxWidth = 856;
    const magicSpacing = 10;
    const cellLength = Math.max(...rows.map((row) => (`${row[accessor]}` || '').length), headerText.length);
    return Math.min(maxWidth, cellLength * magicSpacing);
};

ModelDetails.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    updateUser: PropTypes.func,
    paramsVariablesUpdated: PropTypes.object,
    isModelUpdated: PropTypes.object,
    modelModifiedDate: PropTypes.object,
    updateModifiedDate: PropTypes.func,
};

/**
 * Json containation
 * @param {*} o1 option 1
 * @param {*} o2 option 2
 */
function jsonConcat(o1, o2) {
    for (var key in o2) {
        o1[key] = o2[key];
    }
    return o1;
}
